import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from "../Context/HimmaContext";
import {
  AddOrEditChoiceRequestSchema,
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
} from '../client-sdk/api';

const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const localStorageStoreId = userData?.userDetails?.storeId 

export const useChoicesApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createChoice = useCallback(
    async (choiceData: AddOrEditChoiceRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.addChoice(choiceData,localStorageStoreId);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getAllChoices = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        // Only include search parameter if it has a value
        const searchParam =
          query.search && query.search.trim() !== '' ? query.search : undefined;
        const response = await api.getAllChoices(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.merchantId,
          undefined,
          undefined,
          searchParam
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleChoiceStatus(
          toggleSubAdminStatusRequest,localStorageStoreId
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteChoice = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await api.deleteChoices(deleteSubAdmins,localStorageStoreId);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const editChoice = useCallback(
    async (id: any, subAdminData: AddOrEditChoiceRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editChoice(id, subAdminData,localStorageStoreId);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    createChoice,
    getAllChoices,
    getToggleStatus,
    deleteChoice,
    editChoice,
    loading,
    error,
  };
};
